<template>
  <div class="touch-in-bag-info" v-if="init">
    <div class="header-nav">
      <div class="container">
        <div class="row justify-content-between align-items-center mb-2">
          <div class="col-auto">
            <router-link class="back-to-list-link" :to="{ name: 'TouchIn' }">
              <Icon name="chevron-left" size="24" />
            </router-link>
          </div>

          <div class="col-auto">
            <div class="row no-gutters align-items-center">
              <span class="drawer-name">
                <div class="row align-items-center no-gutters">
                  <!-- <div class="col-auto">
                    <b-icon icon="archive"></b-icon>
                  </div> -->
                  <div class="col-auto">
                    {{ touchInBagName }}
                  </div>
                </div>
              </span>
            </div>
          </div>

          <div class="col-auto" v-if="showToolsDiv">
            <div class="row align-items-center no-gutters">
              <div class="col-auto px-1">
                <b-dropdown variant="link" toggle-class="more-option-btn" right no-caret>
                  <template #button-content>
                    <Icon name="More" size="24" />
                  </template>
                  <b-dropdown-item-button @click="openClothSelectModal">
                    <div class="row no-gutters align-items-center justify-content-start">
                      <div class="col-auto">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20.5 12.5H17.9415C17.2458 12.5 16.8979 12.5 16.636 12.6888C16.3742 12.8775 16.2642 13.2075 16.0442 13.8675L15.9558 14.1325C15.7358 14.7925 15.6258 15.1225 15.364 15.3112C15.1021 15.5 14.7542 15.5 14.0585 15.5H9.94152C9.2458 15.5 8.89794 15.5 8.63605 15.3112C8.37416 15.1225 8.26416 14.7925 8.04415 14.1325L7.95585 13.8675C7.73584 13.2075 7.62584 12.8775 7.36395 12.6888C7.10206 12.5 6.7542 12.5 6.05848 12.5H3.5" stroke="#404040" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M9.5 9.5L12 12M12 12L14.5 9.5M12 12L12 5" stroke="#404040" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M6.5 8.5L4.78246 9.64502C4.31358 9.95761 4.07914 10.1139 3.90942 10.3204C3.75917 10.5032 3.64643 10.7139 3.57767 10.9403C3.5 11.196 3.5 11.4778 3.5 12.0413V15.62C3.5 16.6281 3.5 17.1321 3.69619 17.5172C3.86876 17.8559 4.14413 18.1312 4.48282 18.3038C4.86786 18.5 5.37191 18.5 6.38 18.5H17.62C18.6281 18.5 19.1321 18.5 19.5172 18.3038C19.8559 18.1312 20.1312 17.8559 20.3038 17.5172C20.5 17.1321 20.5 16.6281 20.5 15.62V12.0413C20.5 11.4778 20.5 11.196 20.4223 10.9403C20.3536 10.7139 20.2408 10.5032 20.0906 10.3204C19.9209 10.1139 19.6864 9.95761 19.2175 9.64502L17.5 8.5" stroke="#404040" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div class="col-auto pl-2">
                        移入
                      </div>
                    </div>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="exportBtnClicked" v-if="hasCloth">
                    <div class="row no-gutters align-items-center justify-content-start">
                      <div class="col-auto">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.5 8.5L4.78246 9.64502C4.31358 9.95761 4.07914 10.1139 3.90942 10.3204C3.75917 10.5032 3.64643 10.7139 3.57767 10.9403C3.5 11.196 3.5 11.4778 3.5 12.0413V15.62C3.5 16.6281 3.5 17.1321 3.69619 17.5172C3.86876 17.8559 4.14413 18.1312 4.48282 18.3038C4.86786 18.5 5.37191 18.5 6.38 18.5H17.62C18.6281 18.5 19.1321 18.5 19.5172 18.3038C19.8559 18.1312 20.1312 17.8559 20.3038 17.5172C20.5 17.1321 20.5 16.6281 20.5 15.62V12.0413C20.5 11.4778 20.5 11.196 20.4223 10.9403C20.3536 10.7139 20.2408 10.5032 20.0906 10.3204C19.9209 10.1139 19.6864 9.95761 19.2175 9.64502L17.5 8.5" stroke="#4D4D4D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M20.5 12.5H17.9415C17.2458 12.5 16.8979 12.5 16.636 12.6888C16.3742 12.8775 16.2642 13.2075 16.0442 13.8675L15.9558 14.1325C15.7358 14.7925 15.6258 15.1225 15.364 15.3112C15.1021 15.5 14.7542 15.5 14.0585 15.5H9.94152C9.2458 15.5 8.89794 15.5 8.63605 15.3112C8.37416 15.1225 8.26416 14.7925 8.04415 14.1325L7.95585 13.8675C7.73584 13.2075 7.62584 12.8775 7.36395 12.6888C7.10206 12.5 6.7542 12.5 6.05848 12.5H3.5" stroke="#4D4D4D" stroke-width="1.8"/>
                          <path d="M9.5 5.5L12 3M12 3L14.5 5.5M12 3L12 10" stroke="#4D4D4D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div class="col-auto pl-2">
                        移出
                      </div>
                    </div>
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="openChangeNameModal">
                    <div class="row no-gutters align-items-center justify-content-start">
                      <div class="col-auto">
                        <Icon name="edit" size="22"/>
                      </div>
                      <div class="col-auto pl-2">
                        編輯
                      </div>
                    </div>
                  </b-dropdown-item-button>
<!--                  <b-dropdown-item-button @click="openDeleteConfirmModal">-->
<!--                    <div class="row no-gutters align-items-center justify-content-start text-danger">-->
<!--                      <div class="col-auto">-->
<!--                        <icon name="delete" size="22"></icon>-->
<!--                        &lt;!&ndash; <b-icon icon="trash"></b-icon> &ndash;&gt;-->
<!--                      </div>-->
<!--                      <div class="col-auto pl-2">-->
<!--                        刪除-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </b-dropdown-item-button>-->
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>

        <div class="ai-missions" v-if="hasMissions">
          <p>正在建立中的 AI 任務... (共 {{ aiMissionInThisBag.length }} 個)</p>
          <div class="scr-div">
            <ul>
              <li v-for="mission in aiMissionInThisBag" :key="mission.serial">
                <div class="ai-mission">
                  <img :src="mission.missionImgUrl" alt="">
                  <div class="mission-mask"><span class="mission-spinner"></span></div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="row align-items-center flex-nowrap">

          <div class="col-auto position-relative pr-0">
            <button class="search-btn" :class="{'advanced': hasAdvancedFilter}" @click="searchBtnClicked">
              <Icon name="search-light-grey" size="24" />
            </button>
          </div>

          <div class="col position-relative overflow-hidden">
            <ClothCategoryTabs :srcCloths="clothInBag" @set="setCategoryFilter" hide-empty-tabs></ClothCategoryTabs>
          </div>
        </div>

      </div>
    </div>

    <div class="body-cloths">
      <div class="container">
        

        <ClothCardList
          v-if="hasCloth"
          ref="cardList"
          :cloths="clothInBag"
          :filters="filters"
          :sortType="sortType"
          :sortDirectionDesc="sortDirectionDesc"
          :mode="clothListMode"
          :selectedIds="selectedClothIds"
          :showTitle="blockShowText"
          @clothClicked="clothClicked">
        </ClothCardList>

        <div class="empty-msg" v-if="showMiddleToolDiv">
          <p class="text-center">
            <span>還沒有衣服在這個壓縮袋裡喔！</span><br>
            <span>請從衣櫥中移動單品或直接新增單品</span>
          </p>

          <b-button class="option-btn" variant="outline-primary" @click="openClothSelectModal">
            <Icon name="Archive_alt_add_light" size="24" />
            選取單品
          </b-button>

          <CropImageButton @emitPostRequest="handleCropImagePost" enable-emit-post>
            <b-button class="option-btn" variant="outline-primary">
              <Icon name="circle-add" size="24"/>
              快速新增單品
            </b-button>
          </CropImageButton>
        </div>
      </div>
      <div class="export-confirm-div" :class="{'selection-empty': selectedClothIds.length === 0}" v-if="showExportConfirmDiv">
        <button class="confirm-btn" @click="exportConfirmBtnClicked">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.5 8.5L4.78246 9.64502C4.31358 9.95761 4.07914 10.1139 3.90942 10.3204C3.75917 10.5032 3.64643 10.7139 3.57767 10.9403C3.5 11.196 3.5 11.4778 3.5 12.0413V15.62C3.5 16.6281 3.5 17.1321 3.69619 17.5172C3.86876 17.8559 4.14413 18.1312 4.48282 18.3038C4.86786 18.5 5.37191 18.5 6.38 18.5H17.62C18.6281 18.5 19.1321 18.5 19.5172 18.3038C19.8559 18.1312 20.1312 17.8559 20.3038 17.5172C20.5 17.1321 20.5 16.6281 20.5 15.62V12.0413C20.5 11.4778 20.5 11.196 20.4223 10.9403C20.3536 10.7139 20.2408 10.5032 20.0906 10.3204C19.9209 10.1139 19.6864 9.95761 19.2175 9.64502L17.5 8.5" stroke="#4D4D4D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.5 12.5H17.9415C17.2458 12.5 16.8979 12.5 16.636 12.6888C16.3742 12.8775 16.2642 13.2075 16.0442 13.8675L15.9558 14.1325C15.7358 14.7925 15.6258 15.1225 15.364 15.3112C15.1021 15.5 14.7542 15.5 14.0585 15.5H9.94152C9.2458 15.5 8.89794 15.5 8.63605 15.3112C8.37416 15.1225 8.26416 14.7925 8.04415 14.1325L7.95585 13.8675C7.73584 13.2075 7.62584 12.8775 7.36395 12.6888C7.10206 12.5 6.7542 12.5 6.05848 12.5H3.5" stroke="#4D4D4D" stroke-width="1.8"/>
            <path d="M9.5 5.5L12 3M12 3L14.5 5.5M12 3L12 10" stroke="#4D4D4D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="cancel-btn" @click="exportCancelBtnClicked">
          取消
        </button>
      </div>
    </div>

    <CustomModalFooter v-if="showBottomToolDiv">
      <div class="row">
        <div class="col-6">
          <b-button class="option-btn w-100" variant="outline-primary" @click="openClothSelectModal">
            <Icon name="Archive_alt_add_light" size="24" />
            選取單品
          </b-button>

        </div>
        <div class="col-6">
          <CropImageButton @emitPostRequest="handleCropImagePost" enable-emit-post>
            <b-button class="option-btn w-100" variant="outline-primary">
              <Icon name="circle-add" size="24"/>
              快速新增
            </b-button>
          </CropImageButton>
        </div>
      </div>
    </CustomModalFooter>

    <!-- 移入單品的視窗 -->
    <Transition name="fade">
      <ClothSelectModal
          v-model="showClothSelectModal"
          :cloths="importModalCloths"
          title="加入單品"
          @confirm="moveIntoBag"
          @back="closeClothSelectModal"
          @skip="closeClothSelectModal"
      />
    </Transition>

    <!-- 選擇移出的目的地 -->
    <TouchInBagSelectBottomModal v-if="showMoveToModal" :exceptSerials="[bagData.serial]" @close="closeMoveToModal" @confirm="moveCloths"></TouchInBagSelectBottomModal>

    <!-- 刪除抽屜確認 -->
    <transition name="fade">
      <WcCommonModal v-if="showDeleteConfirmModal" title="刪除確認" @close="closeDeleteConfirmModal" @cancel="closeDeleteConfirmModal" @backClick="closeDeleteConfirmModal" @ok="deleteDrawer">
        <p>確定要刪除壓縮袋【{{ touchInBagName }}】嗎?</p>
      </WcCommonModal>
    </transition>

    <!-- 修改編輯抽屜 -->
    <WcBottomModal v-if="showChangeNameModal" :confirmDisabled="changeNameDisabled" @confirm="editTouchInBag" @backClick="closeChangeNameModal" @close="closeChangeNameModal">
      <div class="container">
        <CustomInputGroup v-model="inputBagName" labelText="輸入壓縮袋名稱" />
      </div>
    </WcBottomModal>

    <!-- 進階搜尋 -->
    <ClothFilterModal v-if="bottomFilterShow"
                      @back="closeFilterModal"
                      @confirm="confirmFilterModal"
                      :filterTags="filterTags"
                      :filterColors="filterColors"
                      :filterPublic="filterPublic"
                      :sortType="sortType"
                      :sortDirectionDesc="sortDirectionDesc"
                      :showBlockText="blockShowText"
                      :hideSortType="['recycleTime']">
    </ClothFilterModal>

    <b-modal size="sm" content-class="custom-modal" v-model="showNeedMorePointModal" centered hideFooter>
      <div>
        <p>點數不足，每次使用此功能需要消耗 10 個織點，目前的織點點數為 {{user.wcPoint}} 點，無法使用此功能。</p>
      </div>
      <div>
        <b-button variant="primary" class="w-100" @click="showChargeModal">前往購買點數</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import commonBusyAndErrorHandling from '@/assets/js/commonBusyAndErrorHandling.js';
import ClothCardList from '@/components/clothList/ClothCardList.vue';
import ClothCategoryTabs from '@/components/clothList/ClothCategoryTabs.vue';
import TouchInBagSelectBottomModal from "@/components/touchInBag/TouchInBagSelectBottomModal.vue";
import WcCommonModal from '@/components/commons/WcCommonModal.vue';
import WcBottomModal from '@/components/commons/WcBottomModal.vue';
import ClothSelectModal from "@/components/commons/ClothSelectModal.vue";
import ClothFilterModal from "@/components/clothList/ClothFilterModal.vue";
import CustomInputGroup from "@/components/commons/CustomInputGroup.vue";
import CropImageButton from "@/components/cropImage/CropImageButton.vue";
import CustomModalFooter from '@/components/CustomModalFooter.vue';

export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'TouchInBagInfo',
  data() {
    return {
      ReadingBusy: 'TouchInBagInfoReading',
      SavingBusy: 'TouchInBagInfoSaving',

      init: false,
      touchInBagSerial: -1,
      bagData: {},

      selectedClothIds: [],
      sortType: 'category',
      sortDirectionDesc: false,
      blockShowText: false,
      clothListMode: 'view',

      inputBagName: '',

      // filter
      fillCategory1: -1,
      filterPublic: -1,
      filterTags: [],
      filterColors: [],

      showClothSelectModal: false,
      showMoveToModal: false,
      showOptModal: false,
      showDeleteConfirmModal: false,
      showChangeNameModal: false,
      bottomFilterShow: false,

      showNeedMorePointModal: false,
    };
  },
  props: {
  },
  components: {
    CustomInputGroup,
    ClothFilterModal,
    ClothCardList,
    ClothCategoryTabs,
    TouchInBagSelectBottomModal,
    WcCommonModal,
    WcBottomModal,
    ClothSelectModal,
    CropImageButton,
    CustomModalFooter,
  },
  computed: {
    ...mapState(['user', 'cloths', 'clothCategories']),
    ...mapState('aiMission', ['missions']),
    ...mapGetters(['isTester']),

    aiMissionInThisBag() {
      return this.missions.filter((m) => {
        return (m.status === 0 || m.status === 1) && m.type === 10 && m.inputObject.saveTargetType === 'touchin' && m.inputObject.saveTargetSerial === this.touchInBagSerial;
      });
    },
    touchInBagName() {
      return this.bagData.name;
    },
    clothInBag() {
      const cs = this.cloths.filter((c) => {
        return !c.isDeleted && c.recycleType === -1 && c.touchInBagSerial === this.bagData.serial;
      });
      return cs;
    },
    importModalCloths() {
      return this.cloths.filter((c) => {
        return !c.isDeleted && c.recycleType === -1 && c.touchInBagSerial === -1;
      });
    },
    filters() {
      const filter = [];
      if (this.fillCategory1 !== -1) {
        filter.push({
          type: 'category1',
          value: this.fillCategory1
        });
      }
      if (this.filterTags.length > 0) {
        filter.push({
          type: 'tags',
          value: this.filterTags
        });
      }
      if (this.filterColors.length > 0) {
        filter.push({
          type: 'color',
          value: this.filterColors,
        });
      }
      if (this.filterPublic !== -1) {
        filter.push({
          type: 'isPublic',
          value: this.filterPublic === 1,
        });
      }
      return filter;
    },
    hasAdvancedFilter() {
      for (const f of this.filters) {
        if (f.type !== 'category1') {
          return true;
        }
      }
      return false;
    },
    clothInUseDataLength() {
      const dataLength = [this.clothInBag.length];
      for (const c of this.clothCategories) {
        const length = this.clothInBag.filter((cloth) => {
          return cloth.category1 === c.serial;
        }).length;
        dataLength.push(length);
      }
      return dataLength;
    },
    hasCloth() {
      return this.clothInBag.length > 0;
    },
    hasMissions() {
      return this.aiMissionInThisBag.length > 0;
    },
    showToolsDiv() {
      return this.clothListMode === 'view';
    },
    showExportConfirmDiv() {
      return this.clothListMode === 'select';
    },
    changeNameDisabled() {
      const t = this.inputBagName.trim().length;
      return t === 0 || t > 10;
    },
    showMiddleToolDiv() {
      return this.clothListMode === 'view' && !this.hasCloth && !this.hasMissions;
    },
    showBottomToolDiv() {
      return this.clothListMode === 'view' && (this.hasCloth || this.hasMissions);
    }
  },
  mounted() {
    try {
      const touchInBagSerial = parseInt(this.$route.params.serial);
      if (touchInBagSerial && !isNaN(touchInBagSerial)) {
        this.touchInBagSerial = touchInBagSerial;
      } else {
        throw new Error('讀取壓縮袋序號失敗');
      }
      this.refresh();
      this.init = true;
    } catch (error) {
      console.error(error);
      this.errorRedirect();
    }
  },
  methods: {
    ...mapActions(['showMsgModal', 'appendComponentBusy', 'clearComponentBusy', 'refreshUser', 'appendErrorMsg', 'updateCloth', 'refreshCloths']),
    ...mapActions('cloth', ['setClothData', 'openClothManager']),
    ...mapActions('globalMsgModal', ['openMsgModal']),
    ...mapActions('aiMission', ['pushCreateClothMission']),

    async refresh() {
      this.appendComponentBusy(this.ReadingBusy);
      try {
        const info = await this.$store.dispatch('api/getTouchInBagInfoPromise', this.touchInBagSerial);
        if(info) {
          this.bagData = Object.assign({}, info);
        }
      } catch (error) {
        this.appendErrorMsg(error);
      } finally {
        this.clearComponentBusy(this.ReadingBusy);
      }
    },
    errorRedirect() {
      this.$router.push({name: 'TouchIn'});
    },
    setCategoryFilter(category) {
      this.fillCategory1 = category.value;
    },
    async clothClicked(cloth) {
      if (this.clothListMode === 'select') {
        const index = this.selectedClothIds.indexOf(cloth.serial);
        if (index === -1) {
          console.log('not found');
          this.selectedClothIds.push(cloth.serial);
        } else {
          console.log('found');
          this.selectedClothIds.splice(index, 1);
        }
      } else {
        const defaultObj = {
          clothId: cloth.serial,
          clothType: 'view',
          clothImgUrl: '',
        };
        await this.setClothData(defaultObj);
        this.openClothManager();
      }
    },
    openClothSelectModal() {
      this.showClothSelectModal = true;
    },
    closeClothSelectModal() {
      this.showClothSelectModal = false;
    },
    async clothMoved(cloths) {
      this.closeClothSelectModal();
      await this.openMsgModal({
        title: '收納成功',
        message: `將 ${cloths.length} 件衣服收進 ${this.touchInBagName} 壓縮袋中。`,
        autoClose: true,
      });
    },
    exportBtnClicked() {
      if (this.hasCloth) {
        this.clothListMode = 'select';
      }
    },
    optAction(action) {
      if (action === 'delete') {
        this.optDeleteClicked();
      } else if (action === 'edit') {
        this.optEditClicked();
      }
    },
    optDeleteClicked() {
      this.closeOptModal();
      this.openDeleteConfirmModal();
    },
    optEditClicked() {
      this.closeOptModal();
      this.openChangeNameModal();
    },
    openDeleteConfirmModal() {
      this.showDeleteConfirmModal = true;
    },
    closeDeleteConfirmModal() {
      this.showDeleteConfirmModal = false;
    },
    deleteDrawer() {
      this.handleAsyncTask(async () => {
        await this.$store.dispatch('api/postDrawerDeletePromise', this.drawer.serial);
        this.refreshCloths();
        this.closeDeleteConfirmModal();
        this.$router.push({name: 'TouchIn'});
      });
    },
    openChangeNameModal() {
      this.inputBagName = this.touchInBagName;
      this.showChangeNameModal = true;
    },
    closeChangeNameModal() {
      this.showChangeNameModal = false;
    },
    editTouchInBag() {
      this.handleAsyncTask(async () => {
        const name = this.inputBagName.trim();
        const bagData = await this.$store.dispatch('api/postTouchInBagUpdatePromise', {
          serial: this.bagData.serial,
          name,
          colorCode: '#000', // colorCode暫時用不到
        });
        this.$emit('updated', bagData);
        await this.refresh();
        await this.openMsgModal({
          title: '編輯成功',
          message: `已將壓縮袋更名為【${bagData.name}】。`,
          autoClose: true,
        });
        this.closeChangeNameModal();
      });      
    },
    exportCancelBtnClicked() {
      this.clothListMode = 'view';
      this.selectedClothIds.splice(0);
    },
    exportConfirmBtnClicked() {
      if (this.selectedClothIds.length > 0) {
        this.showMoveToModal = true;
      } else {
        console.log('沒有選擇的單品');
      }
    },
    closeMoveToModal() {
      this.showMoveToModal = false;
    },
    moveCloths(touchInBagSerial) {
      this.handleAsyncTask(async () => {
        try {
          let list = [];
          if (touchInBagSerial === -1) {
            list = await this.$store.dispatch('api/postTouchInBagRemoveFromBagPromise', this.selectedClothIds);
          } else {
            list = await this.$store.dispatch('api/postTouchInBagMoveIntoPromise', {
              to: touchInBagSerial,
              cloths: this.selectedClothIds
            });
          }
          for (const c of list) {
            this.updateCloth(c);
          }
          this.showMsgModal(`已移動 ${this.selectedClothIds.length} 件衣服`);
          this.closeMoveToModal();
          this.exportCancelBtnClicked();
        } catch (error) {
          this.appendErrorMsg(error);
        }
      });
    },
    searchBtnClicked() {
      this.bottomFilterShow = true;
    },
    closeFilterModal() {
      this.bottomFilterShow = false;
    },
    confirmFilterModal(filter) {
      // console.log(filter);
      this.filterColors.splice(0, this.filterColors.length);
      for (const c of filter.filterColors) {
        this.filterColors.push(c);
      }
      this.filterTags.splice(0, this.filterTags.length);
      for (const c of filter.filterTags) {
        this.filterTags.push(c);
      }
      this.filterPublic = filter.filterPublic;
      this.sortType = filter.sortType;
      this.sortDirectionDesc = filter.sortDesc;
      this.blockShowText = filter.showBlockText;
      this.closeFilterModal();

    },
    test() {
      this.openMsgModal({
        title: 'TouchIn 智慧壓縮袋已成功綁定',
        message: `此壓縮袋已與您的帳號連結，現在手機靠近貼紙，即可出現內容物。`,
        autoClose: true,
      });
    },
    async moveIntoBag(selectedIds) {
      const moveParams = {
        to: this.bagData.serial,
        clothes: selectedIds,
      }
      this.appendComponentBusy(this.ReadingBusy);
      try {
        const res = await this.$store.dispatch('api/postTouchInBagMoveIntoPromise', moveParams);
        console.log(res)
        if(res) {
          await this.refresh();
          await this.refreshCloths();
          await this.clothMoved(selectedIds);
        }
      } catch (error) {
        this.appendErrorMsg(error);
      } finally {
        this.clearComponentBusy(this.ReadingBusy);
      }
    },
    async handleCropImagePost(cropObj) {
      // 處理裁剪後的圖片上傳
      await this.refreshUser();
      const cost = 10;
      if (this.user.wcPoint < cost) {
        this.showNeedMorePointModal = true;
        // this.showMsgModal(`點數不足，目前的點數為 ${this.nowUserWcPoint} 點，無法使用此功能。`);
        return;
      }
      this.handleAsyncTask(async() => {
        await this.pushCreateClothMission({
          base64Img: cropObj.img,
          saveTargetType: 'touchin',
          saveTargetSerial: this.touchInBagSerial,
        });
      });
      console.log(this.user);
      console.log('Cropped image base64:', cropObj.img);
    },
    showChargeModal() {
      this.showNeedMorePointModal = false;
      this.$store.dispatch('setWcPointManageShow', true);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.touch-in-bag-info {
  .header-nav {
    position: sticky;
    top: 0;
    background-color: #fff;
    padding: .5rem 0;
    z-index: 10;
    .back-to-list-link {
      // display: none;
    }

    .drawer-name {
      font-size: 1.2em;
      font-weight: 600;
    }
    ::v-deep .dropdown.b-dropdown.btn-group {
      >button {
        padding: 0;
      }
    }
  }

  .search-btn {
    border: none;
    background-color: transparent;
    padding: .25rem .5rem;
    &.advanced path {
      stroke: var(--icon-color-highlight);
    }
  }

  .ai-missions {
    margin-bottom: .5rem;
    p {
      font-weight: 600;
      margin-bottom: .2rem;
    }
    .scr-div {
      overflow-x: auto;
      white-space: nowrap;
    }
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        margin: 0;
        padding: 0;
        display: inline-block;
        margin-right: .5rem;
        .ai-mission {
          width: 100px;
          border-radius: .5rem;
          border: solid 1px #ccc;
          overflow: hidden;
          position: relative;
          >img {
            width: 100%;
            aspect-ratio: 1 / 1;
            display: block;
            object-fit: cover;
          }
          .mission-mask {
            position: absolute;
            inset: 0;
            background-color: rgba(0, 0, 0, .5);
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .mission-spinner {
            width: 1.5rem;
            height: 1.5rem;
            border: 3px solid rgba(255, 255, 255, .4);
            border-top-color: #fff;
            border-radius: 50%;
            animation: mission-spin .8s linear infinite;
          }
        }
      }
    }
  }

  .body-cloths {
    padding-bottom: 8rem;
    position: relative;

    
    .empty-msg {
      position: relative;
      height: 50vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      row-gap: 1rem;
    }
    .option-btn {
      display: flex;
      align-items: center;
      gap: .5rem;
    }
    .export-confirm-div {
      position: fixed;
      bottom: 5.5rem;
      left: 50%;
      transform: translate(-50%, 0);
      border-radius: 999px;
      background-color: #fff;
      box-shadow: 0 4px 12px 0px $typography-secondary-default;
      padding: 0 4px;
      .confirm-btn {

      }
      &.selection-empty {
        .confirm-btn {
          opacity: .6;
        }
      }
      button {
        border: none;
        background-color: transparent;
        padding: 8px 12px; 
        &:not(:first-child) {
          border-left: solid 1px $typography-secondary-default;
        }
      }
      
      .cancel-btn {

      }
    }
  }
}

@keyframes mission-spin {
  to { transform: rotate(360deg); }
}
</style>